// Status color configuration
const statusColors = {
    'completed': '#10b981',    // Green
    'preparing': '#f59e0b',    // Yellow/Orange  
    'pending': '#3b82f6',      // Blue
    'cancelled': '#ef4444',    // Red
    'processing': '#8b5cf6',   // Purple
    'delivering': '#06b6d4',    // Cyan
    'delivered': '#059669',    // Dark Green
    'refunded': '#dc2626'      // Dark Red
};

/**
 * Get consistent color for a given status
 * @param {string} status - The status name (can include hyphens, underscores, spaces)
 * @returns {string} The color code for the status
 */
export const getStatusColor = (status) => {
    // Normalize status: convert to lowercase and remove hyphens, underscores, spaces
    const normalizedStatus = status.toLowerCase().replace(/[-_\s]/g, '');
    
    // Return the color or default gray if status not found
    return statusColors[normalizedStatus] || '#6b7280';
};

/**
 * Get all available status colors
 * @returns {Object} Object containing all status colors
 */
export const getStatusColors = () => {
    return { ...statusColors };
};
